import clsx from "clsx";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { useAppSelector } from "src/redux/redux-hooks";
import { EventDetail, MarketEventI, MarketFancyI, MarketRunnerI } from "src/types/eventDetail";
import { findMarketLimit } from "src/utils/functions";

interface BetButtonProps {
  type: "back" | "lay";
  index: "1" | "2" | "3";
  odds?: number;
  size?: number;
  runner?: MarketRunnerI;
  currentMarket?: MarketEventI;
  fancyMarket?: MarketFancyI;
  event?: EventDetail;
  curMarketExposure?: any[];
  sparkMs?: number;
  btnTypeEnum?: "normal" | "race" | "fancy";
}

function LTSBetButton({
  type,
  index,
  odds,
  size,
  runner,
  currentMarket,
  fancyMarket,
  event,
  curMarketExposure = [],
  btnTypeEnum = "normal",
}: BetButtonProps) {
  const isFancy = fancyMarket?.market_type === "fancy";
  const marketType = isFancy ? fancyMarket?.market_type : currentMarket?.market_type;

  const mounted = useRef(false);
  const [isOddUpdated, setIsOddUpdated] = useState<"NA" | "UP" | "DOWN">("NA");
  const [disabled, setDisabled] = useState(false);
  //   const { setCurrentbetSlip, currentBetSlip, setCalculateRunnerExposure } = useCurrentBetSlip();
  //   const { setExposures, setFancyExposures } = useExposures();
  const { userData } = useAppSelector((state) => state.user);
  //   const fromOneClick = userData?.is_one_click_bet_enable;

  const marketLimit = useMemo(() => {
    if (isFancy) {
      const marketLimit = findMarketLimit({
        market_limits: fancyMarket?.market_limits,
        currency_id: userData?.currency_id,
      });

      return marketLimit;
    }
    const marketLimit = findMarketLimit({
      market_limits: currentMarket?.market_limits,
      currency_id: userData?.currency_id,
    });

    return marketLimit;
  }, [currentMarket?.market_limits, fancyMarket?.market_limits, userData?.currency_id, isFancy]);

  const curOdd = useRef(odds);

  useEffect(() => {
    if (!odds || Number(odds) === 0) {
      setDisabled(true);
    } else if (marketType === "match_odd" && Number(odds) >= 11) {
      setDisabled(true);
    } else setDisabled(false);

    if (!mounted.current) {
      mounted.current = true;
      return;
    }

    if (curOdd.current) {
      if (curOdd.current > Number(odds)) {
        setIsOddUpdated("DOWN");
      } else if (curOdd.current < Number(odds)) {
        setIsOddUpdated("UP");
      }
    }

    curOdd.current = odds;

    setTimeout(() => {
      setIsOddUpdated("NA");
    }, 300);
  }, [odds, marketType]);

  if (btnTypeEnum === "fancy") {
    return (
      <div
        className={clsx("bl-box", {
          lay: type === "lay",
          back: type === "back",
        })}
        style={{
          ...(isOddUpdated === "UP" && {
            backgroundColor: "green",
          }),
          ...(isOddUpdated === "DOWN" && {
            backgroundColor: "red",
          }),
        }}
      >
        {odds ? (
          <>
            <span className="d-block odds">{odds}</span>
            <span className="d-block">{size}</span>
          </>
        ) : (
          <span className="d-block odds">-</span>
        )}
      </div>
    );
  }

  return (
    <Fragment>
      <div
        // className="bl-box back back2"
        className={clsx("bl-box", {
          "back back2": type === "back" && index === "3",
          "lay lay2": type === "lay" && index === "3",
          "back back1": type === "back" && index === "2",
          "lay lay1": type === "lay" && index === "2",
          back: type === "back" && index === "1",
          lay: type === "lay" && index === "1",
          //   blink: isOddUpdated,
          "disabled-bet": disabled,
        })}
        style={{
          ...(isOddUpdated === "UP" && {
            backgroundColor: "green",
          }),
          ...(isOddUpdated === "DOWN" && {
            backgroundColor: "red",
          }),
        }}
      >
        {odds ? (
          <>
            <span className="d-block odds">{odds}</span>
            <span className="d-block">{size}</span>
          </>
        ) : (
          <span className="d-block odds">-</span>
        )}
      </div>
    </Fragment>
  );
}

export default LTSBetButton;
